import { useTranslation } from 'react-i18next';

export const HeroSection = () => {
  const { t: translate } = useTranslation();

  return (
    <section className="relative min-h-[70vh] lg:min-h-[90vh] flex items-center overflow-hidden bg-white">
      {/* Subtle grid background */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: 'linear-gradient(rgba(0,0,0,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,.1) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="relative container mx-auto px-6 sm:px-12 lg:px-20 z-10 pt-24 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">

          {/* Left Column: Content (7/12 for more air) */}
          <div className="lg:col-span-7 text-center lg:text-left animate-on-scroll">

            {/* Pre-title */}
            <div className="inline-block mb-4">
              <span className="font-audiowide text-sm tracking-[0.2em] text-brand-electric-blue uppercase">{translate('hero.badge')}</span>
            </div>

            {/* Headline */}
            <h1 className="font-audiowide text-4xl sm:text-5xl lg:text-6xl text-[#111111] leading-[1.2] mb-6 tracking-tight">
              {translate('hero.title1')} <br className="hidden lg:block" />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-brand-electric-blue to-brand-neon-green">
                {translate('hero.title2')}
              </span>
            </h1>

            {/* Subheadline */}
            <p className="font-montserrat text-lg sm:text-xl text-gray-500 mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              {translate('hero.description')}
            </p>

            {/* CTAs - Properly sized for impact */}
            <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start mb-10">
              <a href="#contacto" className="px-8 py-4 rounded-xl bg-gradient-to-r from-brand-electric-blue to-brand-neon-green text-white font-montserrat font-bold text-base transition-all hover:-translate-y-1 shadow-lg shadow-brand-neon-green/20 hover:shadow-brand-neon-green/40 flex items-center justify-center min-w-[200px]">
                {translate('hero.cta_demo')}
              </a>
              <a href="/verify" className="px-8 py-4 rounded-xl bg-white border border-gray-100 shadow-sm text-[#111111] font-montserrat font-bold text-base transition-all hover:-translate-y-1 hover:bg-gray-50 flex items-center justify-center min-w-[200px]">
                {translate('hero.cta_start')}
              </a>
            </div>

            {/* Trust Bar */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-8 gap-y-3 font-montserrat text-[12px] text-gray-400 uppercase tracking-widest font-bold">
              <div className="flex items-center gap-2">
                <i className="fas fa-lock text-brand-electric-blue/40 text-xs"></i>
                <span>{translate('hero.trust_records')}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="fas fa-globe text-brand-electric-blue/40 text-xs"></i>
                <span>{translate('hero.trust_support')}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="fas fa-bolt text-brand-electric-blue/40 text-xs"></i>
                <span>{translate('hero.trust_uptime')}</span>
              </div>
            </div>

          </div>

          {/* Right Column: Realistic Diploma Illustration (5/12) */}
          <div className="lg:col-span-5 relative flex justify-center lg:justify-end animate-on-scroll" style={{ animationDelay: '0.2s' }}>
            <div className="relative group">
              {/* Background Glow */}
              <div className="absolute inset-0 bg-brand-electric-blue/5 rounded-full blur-[80px] group-hover:bg-brand-electric-blue/10 transition-all duration-700"></div>

              {/* The Illustration */}
              <div className="relative z-10 animate-float translate-x-4">
                <img
                  src="/images/hero-logistics02.webp"
                  alt="4tlayer Digital Logistics Certificate"
                  className="w-full max-w-[450px] lg:max-w-[580px] transform transition-transform duration-700 group-hover:scale-105 mix-blend-multiply"
                />
              </div>
            </div>
          </div>

        </div>
      </div>

    </section>
  );
};
